import { useEffect, useState } from "react";

/**
 * The value, settled — it lags `value` until typing stops for `delayMs`.
 *
 * For a search box whose term becomes a query variable: without it, every keystroke is a round trip
 * and the results flicker through the prefixes of what is being typed. Two components already
 * hand-rolled this shape with a `useRef` timeout (`ContentEditor`, `QuizQuestion`), both to defer a
 * mutation rather than a query; this is the read-side form.
 */
export const useDebouncedValue = <T>(value: T, delayMs = 300): T => {
    const [
        settled,
        setSettled,
    ] = useState<T>(value);

    useEffect(() => {
        const timer = setTimeout(() => setSettled(value), delayMs);
        // Clears on every change, so only the last keystroke in a burst ever fires.
        return () => clearTimeout(timer);
    }, [
        value,
        delayMs,
    ]);

    return settled;
};
